import { __assign, __rest } from "tslib";
import React from 'react';
import SegmentTabsComponent from '../../../SegmentTabs/SegmentTabs';
var SegmentTabs = function (_a) {
    var segments = _a.segments, props = __rest(_a, ["segments"]);
    return React.createElement(SegmentTabsComponent, __assign({}, props, { segments: segments.map(function (segment) { return (__assign(__assign({}, segment), { isDisabled: false })); }) }));
};
export default SegmentTabs;
